module.exports = __webpack_public_path__ + "img/noneAudio.2a48e5a8.png";